import React from 'react';
import { useTranslation } from 'react-i18next';
import CTA from "../../../components/Constant/cta/CTA";
import WhySection from "../../../components/WhySection/WhySection";
import IntroSection from "../../../components/IntroSection/IntroSection";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../../components/InfoBlocks/InfoBlocks";
import SEO from "../../../utils/SEO";

export default function OffshoreBankAccountOpening() {
    const { t } = useTranslation();
    const tp = (k, d) => t(`pages.offshore-bank-account-opening.${k}`, d);
    const obj = (k) => tp(k, { returnObjects: true });

    return (
        <main className='main'>
            <SEO
                title={tp('seo.title')}
                description={tp('seo.description')}
                keywords={tp('seo.keywords')}
                url="/offshore-bank-account-opening"
            />
            <IntroSection
                title={tp('intro.title')}
                subtitle={tp('intro.subtitle')}
                description={tp('intro.description')}
                badges={obj('intro.badges')}
                buttonText={tp('intro.button')}
                buttonLink="/quote"
                imageSrc={require('../../../assets/images/offshore-bank-account-opening/offshore-bank-account-opening.png')}
                imageAlt={tp('intro.imageAlt')}
            />

            <section className='section'>
                <div className="container">
                    <WhySection
                        title={tp('why.title')}
                        blocks={[{ items: obj('why.items') }]}
                    />

                    <WhySection
                        title={tp('types.title')}
                        blocks={[{ items: obj('types.items') }]}
                    />

                    <WhySection
                        title={tp('jurisdictions.title')}
                        blocks={[{ items: obj('jurisdictions.items') }]}
                    />

                    <WhySection
                        title={tp('how.title')}
                        blocks={[{ items: obj('how.items') }]}
                    />

                    <InfoBlocks
                        title={tp('documents.title')}
                        blocks={obj('documents.blocks')}
                    />

                    <WhySection
                        title={tp('emi.title')}
                        blocks={[{ items: obj('emi.items') }]}
                    />

                    <DetailsSection title={tp('whyUs.title')}
                                    items={obj('whyUs.items')}
                    />


                    <FAQList data={obj('faq.items')} title={tp('faq.title')}/>

                    <Testimonials
                        title={tp('testimonials.title')}
                        testimonials={obj('testimonials.items')}
                    />

                    <CTA
                        title={tp('cta.title')}
                        description={tp('cta.description')}
                        buttonText={tp('cta.button')}
                        buttonLink="/quote"
                    />

                </div>
            </section>
        </main>
    );
};
